import React, { useState, useContext } from 'react';
import styles from './FilmProductionCourseContent.module.css';

import { LanguageContext } from '../LanguageContext/LanguageContext';

const FilmProductionCourseContent = ( CourseContent ) => {
  const [isOpen, setIsOpen] = useState(false);

  const { direction } = useContext(LanguageContext); 

  const toggleContent = () => {
    setIsOpen(!isOpen);
  };



  console.log(CourseContent.CourseContent.Sections);

  return (
    <div className={styles.maincontainer}>
      <div className={styles.collapsibleLtr}>
        <div className={styles.header}>
          <div 
            onClick={toggleContent} 
            className={styles.toggleButton} 
            style={{ cursor: 'pointer', color: '#39FFFb', fontSize: '36px', marginLeft: '10px', marginRight: '10px' }} 
          >
            {isOpen ? '-' : '+'}
          </div>
          <h5 className={styles.toggle}>
            {direction === "rtl" ? 'الدروس' : "Lessons"}
          </h5>
          <hr style={{ opacity: '0.4' }} className={styles.line} />
        </div>
        
        {/* Render course sections when isOpen is true */}
        {isOpen && (
          <div>
            {CourseContent.CourseContent.Sections.map((item, index) => (
              <div key={index}>
                <QuestionItem
                  question={item.sectionName}
                  lessons={item.Lessons}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
  
};


const QuestionItem = ({ question, lessons }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Toggle content visibility when the button is clicked
  const toggleContent = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.questionItem}>
      <div className={styles.questionHeader} onClick={toggleContent}>
        <div className={styles.toggleButton} style={{ cursor: 'pointer', color: '#39FFFb', fontSize: '16px', marginLeft: '10px', marginRight: '10px' }}>
          {isOpen ? '-' : '+'}
        </div>
        <h6 style={{ fontSize: '16px', fontWeight: '800', color: '#5AFFFF', marginBottom: '0px', fontFamily: 'Noto Kufi Arabic' }} className={styles.question}>
          {question}
        </h6>
      </div>
      
      {/* Main Answer Section (Lessons) */}
      {isOpen && (
        <div className={styles.mainAnsTab}>
          <ul style={{ width: '100%', color: 'white'}}>
            {lessons.map((lesson, index) => (
              <li style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingLeft:'20px', paddingRight:'10px' , fontWeight:'400' }} key={index}>
                <span><strong>{lesson.lessonName}</strong> </span>
                <span>{lesson.timing}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};


export default FilmProductionCourseContent;
